import React from "react";
import { useHistory } from "react-router-dom";
import Utils from "../../Common/Utils";
import AuthManager from "../../Common/AuthManager";
import ServiceWrapper from "../../Services/ServiceWrapper";
import AppSettings from "../../Settings/AppSettings";
import PermissionsManager from "../../Common/PermissionsManager";
import Logger from "../../Common/Logger";

function CallbackLogin(props) {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [gmsLoginError, setgmsLoginError] = React.useState(false);
  const [hasAccess, setHasAccess] = React.useState(false);
  const [verifyingAccess, setVerifyingAccess] = React.useState(true);
  const [loadingProfile, setLoadingProfile] = React.useState(false);
  const [profile, setProfile] = React.useState({});
  const api_base_url = AppSettings.SAMS_API_URL;
  const gms_api_url = AppSettings.GMS_BACKEND_API_URL;

  const get_user_name = () => {
    if (profile !== null && profile !== undefined) {
      if (profile.profile !== null && profile.profile !== undefined) {
        return profile.profile.first_name + " " + profile.profile.last_name;
      }
    }
    return "";
  };

  const check_if_user_belongs_to_party = (profileResponse) =>
    profileResponse.profile.parties.filter((party) => party.name === "GMS");

  const goto_dashboard = () =>
    (window.location.href =
      Utils.get_current_root_url() + "workspace/preparing");

  const process_response = async () => {
    AuthManager.logoutUser();
    let gotAccess = false;
    setLoading(true);
    setLoadingProfile(true);
    let qstring = props.location.search;
    qstring = qstring.replace("?t=", "");
    AuthManager.setSamsToken(qstring);
    // await Utils.sleep(3000);

    let profileResponse = await ServiceWrapper.doPost(
      api_base_url + "v1/user/getprofile",
      {},
      null,
      qstring
    );
    setLoading(false);
    setProfile(profileResponse.data);
    setVerifyingAccess(true);
    var profileobj = profileResponse.data;

    if(profileobj){
      localStorage.setItem("merchantList", profileobj.profile?.merchantList ? JSON.stringify(profileobj.profile.merchantList) : []);
    }
    
    if (profileobj.valid) {
      if (check_if_user_belongs_to_party(profileResponse.data)) {
        gotAccess = true;
        setHasAccess(true);
        AuthManager.setAuthUser(profileResponse.data);
      }
      setVerifyingAccess(false);

      var pobj = new PermissionsManager();
      pobj.ProcessPermissions();

      const gmsloginResponse = await ServiceWrapper.doPost(
        gms_api_url + "login",
        { token: qstring },
        null
      );
      if (!gmsloginResponse.errorfound) {
        AuthManager.setGmsToken(gmsloginResponse.data.access_token);

        if (gotAccess) {
          await Logger.log(
            "Success",
            "Signin",
            "Signed In through GMS frontend App.",
            "0"
          );
          await Utils.sleep(500);
          history.replace("/gms/performance");
        }
      } else {
        setgmsLoginError(true);
      }
    }
    setVerifyingAccess(false);
  };

  React.useEffect(() => {
    async function do_process_response() {
      await process_response();
    }
    do_process_response();
  }, []);

  return (
    <React.Fragment>
      <div className="container col-6 h-100 justify-content-center align-items-center">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        {loading && (
          <React.Fragment>
            <div className="bg-white alert alert-primary">
              <span className="spinner-border spinner-border-sm"></span>&nbsp;
              We are fetching your profile information. Please wait.....
            </div>
          </React.Fragment>
        )}
        {loadingProfile && !loading && (
          <React.Fragment>
            <div className="bg-white alert alert-primary">
              <strong>Success!</strong> Welcome{" "}
              <strong>{get_user_name()}</strong>
            </div>
            {!gmsLoginError && (
              <div className="alert alert-warning">
                <strong>Warning!</strong> Please do not press{" "}
                <strong>Refresh</strong> or <strong>Reload</strong> the page.
              </div>
            )}
            {hasAccess && (
              <React.Fragment>
                {!gmsLoginError && (
                  <div className="alert alert-primary">
                    <strong>Info!</strong> Please wait while we take you back to
                    your dashboard
                  </div>
                )}
                {!gmsLoginError && (
                  <div className="alert alert-dark">
                    <span className="spinner-border spinner-border-sm"></span>
                    &nbsp; You are being redirected. Please wait.....
                  </div>
                )}
                {gmsLoginError && (
                  <div className="alert alert-danger">
                    <strong>Oops !</strong> Server Error: Please press{" "}
                    <strong>Reload</strong>&nbsp;&nbsp;or&nbsp;
                    <strong>Login</strong>&nbsp;button&nbsp;&nbsp;
                    <button
                      type="button"
                      onClick={() => window.location.reload()}
                      className="btn btn-info btn-sm"
                    >
                      Reload
                    </button>
                    &nbsp;
                    <a
                      type="button"
                      href="/login"
                      className="btn btn-primary btn-sm"
                    >
                      Login
                    </a>
                  </div>
                )}
              </React.Fragment>
            )}
            {!hasAccess && verifyingAccess && (
              <div className="alert alert-primary">
                <span className="spinner-border spinner-border-sm"></span>
                &nbsp; We are verifying authorisation. Please wait.....
              </div>
            )}
            {!hasAccess && !verifyingAccess && (
              <React.Fragment>
                <div className="alert alert-danger">
                  <strong>Oops!</strong> Sorry, you dont have rights to access
                  this application
                </div>
                <div className="alert alert-dark">
                  If you are lost , Please click&nbsp;
                  <a href="/login">here</a>&nbsp;to login back
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}

export default CallbackLogin;
